<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<p class="mgb_5">
					<span class="int_type mgr_5">
						<select id="dlActive" v-model="active_yn" @change="search()">
							<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
						</select>
					</span>

					<select v-model="partner_type" @change="search()" :disabled="user.customer_only_view">
						<option value="A">All Type</option>
						<option value="C">Customer</option>
						<option value="V">Vendor</option>
						<option value="B">Both</option>
					</select>

					<em class="lt_text">Reg.Date</em>
					<span class="mgr_5"> <CustomDatePicker v-model="crt_date_from"/> ~ <CustomDatePicker v-model="crt_date_to"/></span>

					<em class="lt_text">Grade</em>
					<span class="int_type_no_border mgr_5"> <CodeSelect :width="60" :showDesc="false" :codes="grades" v-model="grade" /> </span>

					<country-select :countries="countries" :bool="true" v-model="country" />

					<em class="lt_text">State</em>
					<span class="int_type_no_border mgr_5"> <CodeSelect :width="60" :codeWidth="120" :showDesc="false" :codes="filteredStates" v-model="state" /> </span>

					<span>
						<em class="lt_text">Sales Group</em>
						<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" :showDesc="false" v-model="sales_group_code" @set-code="setSalesGroup"/></span>
					</span>

					<span>
						<em class="lt_text">Salesman</em>
						<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesmansForSearch" :showDesc="false" v-model="salesman_id" @set-code="setSalesman"/></span>
					</span>

					<span class="int_type mgr_5" style="width: 120px;">
						<input type="text" v-model="keyword" placeholder="Enter Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
					</span>

					<span class="int_type mgr_15" style="width: 120px;">
						<input type="text" v-model="track_no" placeholder="UPS Tracking No" autofocus autocomplete="off" @keyup.enter="search()" />
					</span>

					<span class="int_type ssm_int">
						<input type="text" class="ssm_int" v-model.trim="from_zip_code" title="From Zip Code" placeholder="Zip Code" autofocus autocomplete="off" @keyup.enter="search()" />
					</span>
					~
					<span class="int_type ssm_int mgr_5">
						<input type="text" class="ssm_int" v-model.trim="to_zip_code" title="To Zip Code" placeholder="Zip Code" autofocus autocomplete="off" @keyup.enter="search()" />
					</span>

					<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
					<a href="javascript:void(0);" class="gray_bt mgr_10" @click="reset()">Reset</a>
				</p>
			</div>
		</div>

		<table class="list_tbl">
			<thead>
				<tr>
					<th width="4.5%">
						<a href="javascript:;" @click="sort('code')">Code{{ sortMark('code') }}</a>
					</th>
					<th v-if="company_id == 'minkhair'" width="4.5%">Alt Code</th>
					<th width="3%">Memo</th>
					<th :width="initial_partner_type != 'V' ? '8%' : '20%'">
						<a href="javascript:;" @click="sort('name')">Name{{ sortMark('name') }}</a>
					</th>
					<th v-if="initial_partner_type != 'V'" width="6%">Sales Group</th>
					<th v-if="initial_partner_type != 'V'" width="4%">Salesman</th>
					<th width="6%">Phone 1</th>
					<th width="6%">Phone 2</th>
					<th width="6%">Fax</th>
					<th width="6%">Email</th>
					<!-- <th width="15%">
          <a href="javascript:;" @click="sort('full_name')">Full Name{{ sortMark('full_name') }}</a>
        </th> -->
					<th>Address</th>
					<th width="7%">
						<a href="javascript:;" @click="sort('address_city')">City{{ sortMark('address_city') }}</a>
					</th>
					<th width="3%">
						<a href="javascript:;" @click="sort('address_state')">State{{ sortMark('address_state') }}</a>
					</th>
					<th width="3.5%">
						<a href="javascript:;" @click="sort('address_zipcode')">Zipcode{{ sortMark('address_zipcode') }}</a>
					</th>
					<th width="3%">Country</th>
					<th width="3%">Grade</th>
					<th width="3%">
						<a href="javascript:;" @click="sort('partner_type')">Type{{ sortMark('partner_type') }}</a>
					</th>
					<th width="4%">{{ company_id == 'minkhair' ? 'Contact' : 'Owner' }}</th>
					<!-- <th width="3%">Active</th> -->
					<th width="4%">
						<a href="javascript:;" @click="sort('payment_term_name')">P.T.{{ sortMark('payment_term_name') }}</a>
					</th>
					<th width="2%">Blkd</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="partner in partners" v-bind:key="partner.code">
					<td class="al_left">{{ partner.code }}</td>
					<td class="al_center">
						<a href="javascript:;" @click="memo(partner)"><span :style="partner.memo ? 'color:red;' : ''">MEMO</span></a>
					</td>
					<td class="al_left truncate" :title="partner.name">{{ partner.name }}</td>
					<td class="al_left truncate">{{ partner.sales_group_name }}</td>
					<td class="al_left truncate">{{ partner.salesman_id }}</td>
					<td class="al_left truncate">
						<span :title="partner.telephone">{{ partner.telephone }}</span>
					</td>
					<td class="al_left truncate">
						<span :title="partner.telephone2">{{ partner.telephone2 }}</span>
					</td>
					<td class="al_left truncate">
						<span :title="partner.fax">{{ partner.fax }}</span>
					</td>
					<td class="al_left truncate">
						<a v-bind:href="'mailto:' + partner.email" :title="partner.email">{{ partner.email }}</a>
					</td>
					<!-- <td class="al_left truncate">{{ partner.full_name }}</td> -->
					<td class="al_left truncate">
						<span :title="partner.address_detail">{{ partner.address_detail }}</span>
					</td>
					<td class="al_left truncate">{{ partner.address_city }}</td>
					<td class="al_left truncate">{{ partner.address_state }}</td>
					<td class="al_left truncate">{{ partner.address_zipcode }}</td>
					<td class="al_left truncate" :title="partner.country">{{ partner.country }}</td>
					<td class="al_center">{{ partner.grade_code }}</td>
					<td class="al_center">{{ partner.partner_type }}</td>
					<td class="al_left truncate">
						<span v-if="company_id == 'minkhair'" :title="partner.attention_name">{{ partner.attention_name }}</span>
						<span v-else :title="partner.owner_name">{{ partner.owner_name }}</span>
					</td>
					<!-- <td class="al_center">
						<span :style="partner.active_yn == 'N' ? 'color:red;' : ''">{{ partner.active_yn }}</span>
					</td> -->
					<td class="al_left truncate" :title="partner.payment_term_name">
						{{ partner.payment_term_name }}
					</td>
					<td class="al_center">
						<span v-if="partner.blocked" :title="partner.block_reason"><font color="red">&#10004;</font></span>
					</td>
				</tr>
			</tbody>
		</table>

		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>
		<div class="fl_r int_type mgr_15">
			<select v-model="page_size" @change="search">
				<option value="25">25 per page</option>
				<option value="50">50 per page</option>
				<option value="100">100 per page</option>
				<option value="200">200 per page</option>
			</select>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'Memo'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Partner Memo</template>
			<template slot="body">
				<MemoPopup :partner_code="selected_partner_code" v-on:close="closeModal($event)" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectPartnerList } from '@/api/partner/index.js';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import Paging from '@/components/common/Paging';
import CodeSelect from '@/components/common/CodeSelect';
import Modal from '@/components/common/Modal';
import MemoPopup from '@/components/common/MemoPopup';
import { today } from '@/utils/date';
import CountrySelect from '@/components/common/CountrySelect';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			active_yn: 'A',
			partner_type: 'A',
			keyword: null,

			initial_partner_type: null,

			sort_key: 'code',
			sort_direction: 'ASC',

			crt_date_from: null,
			crt_date_to: null,
			track_no: null,

			partners: [],

			grade: '',
			grades: [],
			state: '',
			states: [],
			territory_code: null,
			territories: [],
			country: '',
			countries: [],
			salesGroups: [],
			sales_group_code: null,
			sales_team_code_by_group: null,
			sales_team_code_by_man: null,
			saveParam: {},
			modalName: '',
			showModal: false,
			selected_partner_code: null,
			salesmans: [],
			salesman_id: null,
			to_zip_code: null,
			from_zip_code: null,

			allSelected: false,
			change_to_sales_group_code: null,
			change_to_salesman_id: null,

			apply_to_old_invoices: false,

			show_credit: true,
			show_PDC: true,
			show_payment: false,
			customer_statement_type: null,
			payment_date: today(),
		};
	},
	computed: {
		filteredStates: function() {
			if (!this.country && this.user.company_id == 'newjigu') return this.states;

			//return this.states;
			var vm = this;
			var fStates = this.states.filter(s => s.country == vm.country);
			//console.log(fStates.length);
			if (fStates.length == 0) vm.state = null;
			//else vm.state = fStates[0].state;

			return fStates;
			//console.log(this.states.filter(s => s.country == vm.country));
			//return this.states.filter(s => s.country == vm.country);
		},
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : '';
		},

		checkedPartner() {
			return this.partners.filter(partner => partner.selected).map(partner => partner.code);
		},
		salesmansForSearch() {
			return this.salesmans.filter(sm => !this.sales_team_code_by_group || sm.sales_team_code === this.sales_team_code_by_group).map(sm => ({ code: sm.user_id, name: sm.name, sales_team_code: sm.sales_team_code }));
		},
		salesmansForChange() {
			return this.salesmans.map(sm => ({ code: sm.user_id, name: sm.name }));
		},
		env: function() {
			return process.env.NODE_ENV;
		},
		companyIsNewjigu() {
			return this.company_id === 'newjigu';
		},
		selectParam() {
			return {
				active_yn: this.active_yn,
				partner_type: this.partner_type,
				keyword: this.keyword,
				grade: this.grade,
				state: this.state,
				country: this.country,
				territory_code: this.territory_code,
				sales_team_code_by_group: this.sales_team_code_by_group,
				sales_team_code_by_man: this.sales_team_code_by_man,
				sales_group_code: this.sales_group_code,
				salesman_id: this.salesman_id,
				//all_sales_group: true,
				include_in_charge: true,
				from_main: true,
				crt_date_from: this.crt_date_from,
				crt_date_to: this.crt_date_to,
				track_no: this.track_no,
				paging_yn: this.paging_yn,
				page_size: Number(this.page_size),
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,
				initial_partner_type: this.initial_partner_type,
				from_zip_code: this.from_zip_code,
				to_zip_code: this.to_zip_code,
			};
		},

		defaultCountry: {
			//parameter 에서 country 가 있으면 true 로 리턴
			get() {
				return this.$route.query.country !== undefined;
			},
			set() {},
		},
	},
	components: {
		CountrySelect,
		//PartnerTable,
		Paging,
		CodeSelect,
		Modal,
		MemoPopup,
		CustomDatePicker,
	},
	methods: {
		setSalesGroup(sg) {
			if (sg) {
				if (sg.sales_team_code !== this.sales_team_code_by_man) {
					this.salesman_id = null;
					this.sales_team_code_by_man = null;
				}

				this.sales_team_code_by_group = sg.sales_team_code;
			} else {
				this.sales_team_code_by_group = null;
			}
		},
		setSalesman(sm) {
			if (sm) this.sales_team_code_by_man = sm.sales_team_code;
			else this.sales_team_code_by_man = null;
		},
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal(rv) {
			this.showModal = false;
			if (rv) this.selectPartners(this.page_no);
		},
		memo(partner) {
			this.selected_partner_code = partner.code;
			this.openModal('Memo');
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key === sort_key) {
				this.sort_direction = this.sort_direction === 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				if (this.sort_key == 'ytd') this.sort_direction = 'DESC';
				else this.sort_direction = 'ASC';
			}
			this.search();
		},
		reset() {
			this.sort_key = 'code';
			this.sort_direction = 'ASC';

			this.keyword = null;
			this.grade = null;
			this.state = null;
			this.country = 'US';
			this.territory_code = null;
			//this.country = '';
			this.sales_team_code_by_group = null;
			this.sales_team_code_by_man = null;
			this.sales_group_code = null;
			this.salesman_id = null;

			this.crt_date_from = null;
			this.crt_date_to = null;
			this.track_no = null;
			this.from_zip_code = null;
			this.to_zip_code = null;

			this.show_credit = true;
			this.show_PDC = true;
			this.show_payment = false;
			this.customer_statement_type = null;
			this.payment_date = today();
		},
		search() {
			this.selectPartners();
		},
		async selectPartners(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			let param = this.selectParam;

			param.simple_view = true;
			const { data } = await apiSelectPartnerList(param);

			//console.log('....' + this.country + '**');
			// if (this.country) this.$session.set('partner_country', this.country);
			// else this.$session.set('partner_country', '__blank');

			this.partners = data.partnerList;
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
		},
		gotoPage(pageNo) {
			this.selectPartners(pageNo);
		},
		selectPartner(selectedPartner) {
			this.$router.push({
				name: 'partnerDetail',
				params: { mode: 'detail' },
				query: { backUri: this.uri, code: selectedPartner.code },
			});
		},

		async index() {
			const { data } = await apiIndex();

			this.grades = data.gradeList;
			this.states = data.stateList;
			this.countries = data.countryList;
			this.salesGroups = data.salesGroupList;
			this.salesmans = data.salesmanList;
			this.territories = data.territoryList;
		},
		async init() {
			await this.index();
			this.active_yn = this.companyIsNewjigu ? 'Y' : 'A';
			if (this.user.customer_only_view) this.partner_type = 'C';
			let query = this.$route.query;
			if (query.country === undefined) {
				this.postCoutryLoading();
			} else {
				this.country = query.country;
			}
			if (query.page_size) this.page_size = query.page_size;
			if (query.sort_key) this.sort_key = query.sort_key;
			if (query.sort_direction) this.sort_direction = query.sort_direction;
			if (query.active_yn) this.active_yn = query.active_yn;
			if (query.partner_type) this.partner_type = query.partner_type;
			if (query.grade) this.grade = query.grade;
			if (query.state) this.state = query.state;
			if (query.territory_code) this.territory_code = query.territory_code;
			if (query.country) this.country = query.country;
			if (query.sales_team_code_by_group) this.sales_team_code_by_group = query.sales_team_code_by_group;
			if (query.sales_team_code_by_man) this.sales_team_code_by_man = query.sales_team_code_by_man;
			if (query.sales_group_code) this.sales_group_code = query.sales_group_code;
			if (query.salesman_id) this.salesman_id = query.salesman_id;
			if (query.crt_date_from) this.crt_date_from = query.crt_date_from;
			if (query.crt_date_to) this.crt_date_to = query.crt_date_to;
			if (query.track_no) this.track_no = query.track_no;
			if (query.keyword) this.keyword = query.keyword;
			if (query.from_zip_code) this.from_zip_code = query.from_zip_code;
			if (query.to_zip_code) this.to_zip_code = query.to_zip_code;

			await this.selectPartners(query.page_no);
		},
		postCoutryLoading() {
			// 	// minkhair는 아직 partner의 country정보가 입력되지 않음. 뉴지구도 디폴트는 전체
			if (['minkhair', 'newjigu'].includes(this.company_id)) return;

			let idx = this.countries.findIndex(c => c.code === 'US');
			if (idx < 0) idx = this.countries.findIndex(c => c.code === 'USA');
			if (idx > -1) this.country = this.countries[idx].code;
		},
	},
	created() {
		let route = this.$route;
		if (route.query.initial_partner_type) {
			this.initial_partner_type = route.query.initial_partner_type;
		} else {
			this.initial_partner_type = route.meta.initial_partner_type;
		}

		this.$store.commit('setSideIndex', 8);

		this.$store.commit('setSelectedMenu', 'nav_li_partner_simple');
		this.$store.commit('setSubTitle', 'Partner -> Info (Simple)');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
		// makeTableResizable();
	},
};
</script>
